<div class="modal-header">
  <h4 class="modal-title pull-left">Add/Invite Users</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">
    <label class="form-label">Enter Email Address</label>
    <div class="textbox-date">
      <tag-input [(ngModel)]="mailIds" (onAdd)="showConfidentialityAgreement()" (onRemove)="showConfidentialityAgreement()" secondaryPlaceholder="Email Address" placeholder="+ Email IDs" [errorMessages]="errorMessages" [validators]="validators" [separatorKeyCodes]="keyCode"></tag-input>
      <h5 class="infotext">
        Use a comma or space to separate multiple email addresses
      </h5>
    </div>
  </div>
  <div>
    <label class="custom-checkbox margin-right-15" for="checkbox14" *ngIf="OMRequireApproval">
      <input [(ngModel)]="OMApproval" type="checkbox">Grant Offering Memorandum Access
      <i></i>
    </label>
  </div>
  <div>
    <label class="custom-checkbox margin-right-15" for="checkbox14" *ngIf="DDRequireApproval">
      <input [(ngModel)]="DDApproval" type="checkbox">Grant Due Diligence Access
      <i></i>
    </label>
  </div>
  <div *ngIf="IsSingleUser&&IsAgreementRequired">
    <label class="custom-checkbox margin-right-15" for="checkbox14">
      <input [(ngModel)]="IsConfidentialityAgreementChecked" (change)="openFileUpload(IsConfidentialityAgreementChecked)" type="checkbox">Confidentiality Agreement Signed
      <i></i>
    </label>
  </div>
  <div class="mt_-15" *ngIf="IsUploadOpen&&IsSingleUser">
    <file-upload [uploadType]="fileUploadType" (selectedFilesListEmitter)=selectedFilesListEmitter($event) [maxFiles]="1" [confidentialityAgreementTypes]="'pdf'" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles" [fileTypes]="fileTypes"></file-upload>
  </div>
  <div class="text-right">
    <button type="button" (click)="modalRef.hide()" class="btn btn-default btn-lg">Cancel</button>
    <button type="button" (click)="AddUser()" class="btn btn-success btn-lg" [disabled]="IsSubmit">Share</button>
  </div>

  <div class="margin-top-30" *ngIf="(UserList!=null&&UserList.length>0 && (OMRequireApproval||DDRequireApproval))" style="overflow:hidden;">
    <h5>People who have access <span class="message-count ml-auto circle-count-1 margin-left-5">{{totalCount}}</span> </h5>
    <div class="table-responsive">
      <table class="table basictable row-border hover">
        <tbody>
          <tr *ngFor="let user of UserList;let i = index">
            <td>
              <ul class="connection-list brokerlist be-exchange-list">
                <li class="clearfix">
                  <img src="{{user.Image}}" *ngIf="user.Image!=null&&user.Image!=''">
                  <img [src]="'/../../../assets/img/default-profile-img.png'" *ngIf="user.Image==null||user.Image==''" />
                  <div class="right">
                    <h6 class="d-flex">
                      <span class="invitee-name">
                        {{user.Name}}
                      </span>
                      <div>
                        <span class="ml-auto d-flex ht-25" style="padding-left: 30px !important;">
                          <span placement="left" *ngIf="(user.CurrentStatus=='Invited'||user.CurrentStatus=='Accepted')&&user.ActivityDate==null" [ngClass]="{'not-available':user.CurrentStatus === 'Invited','greentextlabel':user.CurrentStatus === 'Accepted'}">{{ user.CurrentStatus }}</span>
                          <!--<a class="remove" tooltip="Revoke Access" placement="left" *ngIf="CheckAccess(user)" href="javascript:void(0);" (click)="openModal(template,'deletemodal',user.Id,user.Name)"><i class="icofont icofont-close" aria-hidden="true"></i></a>-->
                        </span>
                      </div>
                    </h6>
                    <p> <span class="data">{{user.Email}}</span></p>
                    <p *ngIf="user.DocumentName!=null&&user.DocumentName!=''"> <span class="data">{{user.DocumentName}}</span></p>
                    <p *ngIf="user.CurrentStatus=='Accepted'&&user.ActivityDate!=null"> <span class="data">{{user.Action}} on: {{_validationService.convertDateTimeToUTCStamp(user.ActivityDate)| date:'MM/dd/yyyy hh:mm a'}}</span></p>
                    <p *ngIf="(user.CurrentStatus=='Invited'||user.CurrentStatus=='Accepted')&&user.ActivityDate==null"> <span class="data">{{_validationService.convertDateTimeToUTCStamp(user.RequestDate)| date:'MM/dd/yyyy hh:mm a'}}</span></p>
                  </div>
                </li>
              </ul>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
<ng-template #template>

  <div class="modal-header">
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefDelete.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure you would like to revoke {{selectedusername}}'s Access?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefDelete.hide()">No</button>
      <button class="btn btn-lg btn-primary" (click)="rejectDocRequest();">Yes</button>
    </div>
  </div>

</ng-template>

